<div class="card !p-0 !mb-4">
    <p-breadcrumb [home]="home" [model]="items" />
</div>

@if (product) {
    <div style="position:absolute; top:-9999px;">
        <div #etiquette id="etiquette-to-convert" style="font-family: 'Segoe UI'; height: 50mm; width: 99.99mm;">
            <img style="float: right; margin-top: 0mm; margin-right: 7mm; height: 1cm" src="picto-etiquette.jpg" alt="image" />
            <div style="color: black; margin-left: 5mm; margin-top: 0mm; border-bottom: 0.7mm solid black; padding-bottom: 0.7mm">
                <p style="font-size: 16px; margin-bottom: 0;"> <span style="font-weight: bold;">REF :</span> {{ product.reference }}</p>
                <p style="line-height: normal; margin-bottom: 3mm; font-family: 'Libre Barcode 128 Text'; font-size: 28px;">*{{ product.reference }}*</p>
                <p style="font-size: 16px; font-weight: bold; margin-bottom: 0;">{{ product.marque?.nom }}</p>
                <p style="min-height: 12mm; margin-right: 7mm; margin-bottom: 0; white-space: pre-wrap; font-style: italic; line-height: normal; font-size: 13px">{{ product.description }}</p>
                <img style="float: right; margin-right: 7mm; height: 0.7cm; padding-bottom: 0.7mm;" src="CE-etiquette.jpg" alt="image" />
                <p style="font-size: 15px; font-weight: bold; margin-bottom: 0;">{{ product.marque?.nom }}</p>
            </div>
        </div>
    </div>
}

<p-tabs [value]="activeTab" [lazy]="true" (valueChange)="onTabChange($event)">
    <div class="flex gap-2">
        <div class="flex-1">
            <p-tablist class="rounded-md overflow-hidden" >
                <p-tab [value]="0">Stocks</p-tab>
                <p-tab [value]="1">Détails</p-tab>
                <p-tab disabled>Équivalences</p-tab>
                <p-tab [value]="3">Expéditions</p-tab>
                <!-- <p-tab [value]="4">Documents</p-tab> -->
                <p-tab disabled>Documents</p-tab>
                <p-tab [value]="5">Historiques</p-tab>
                <p-tab [value]="6">Photos</p-tab>
                <p-tab [value]="7">Diffusions</p-tab>
            </p-tablist>
        </div>
        <!-- <div class="flex flex-row gap-2 items-center">
            <p-button icon="pi pi-chevron-left" [rounded]="true" [text]="true" [disabled]="true" />
            <p-button icon="pi pi-chevron-right" [rounded]="true" [text]="true" [disabled]="true" />
        </div> -->
    </div>
    <div class="grid grid-cols-12 gap-4 mt-4">
        <div class="col-span-4">
            @if (product) {
                <div class="flex flex-row gap-2 mb-4">
                    <div class="flex flex-1 flex-col gap-2">
                        <span class="text-primary-500 dark:text-primary-400 text-2xl">{{product.marque?.nom}}</span>
                        <span class="text-2xl">{{product.reference}}</span>
                    </div>
                    <div class="flex items-end flex-col gap-1">
                        <p-tag severity="contrast" [value]="'#' + product.id_old" class="!text-base"/>
                        <div class="flex flex-row gap-2 items-center">
                            <p-button icon="pi pi-tag" [rounded]="true" [text]="true" (click)="onEtiquettePrint()" />
                            <a [href]="'https://www.google.com/search?q=' + product.marque?.nom?.trim() + '+' + product.reference?.trim()" target="_blank" pButton icon="pi pi-google" [rounded]="true" [text]="true"></a>
                        </div>
                    </div>
                </div>

                @if (isLoadingPhoto) {
                    <div class="flex justify-center">
                        <p-progress-spinner ariaLabel="loading" />
                    </div>
                }
                @else {
                    <p-galleria [value]="product['photos']" [responsiveOptions]="responsiveOptions" [containerStyle]="{ 'max-width': '640px' }" [numVisible]="4">
                        <ng-template #item let-item>
                            <img (click)="showViewer($event)" [src]="apiUrl + item.url" class="object-cover aspect-square w-full cursor-zoom-in" alt="img" />
                        </ng-template>
                        <ng-template #thumbnail let-item>
                            <img [src]="apiUrl + item.thumbnail_url" class="object-cover aspect-square" alt="img" width="60"/>
                        </ng-template>
                    </p-galleria>
                }
            }
        </div>
        <div class="col-span-8">
            @if(product.modification_ebay_a_verifier){
                <div class="mb-4 p-2 rounded-md border border-orange-500 dark:border-orange-400 text-orange-500 dark:text-orange-400">
<!--                    <p-message severity="warn" variant="outlined" icon="pi pi-exclamation-triangle">-->
                        <div class="flex flex-row gap-2 items-center">
                            <div class="flex-none"><i class="pi pi-exclamation-triangle"></i></div>
                            <div class="flex-auto">
                                Attention, ce produit a été modifié par {{ product.modification_ebay_par }} le {{ product.modification_ebay_le | date:'shortDate' }} sur les éléments suivants :
                                @for (modif of product.colonnes_modifies; track modif) {
                                    <p-tag [value]="modif" [rounded]="true" severity="warn" class="mr-2"></p-tag>
                                }
                            </div>
                            <div class="flex-none">
                                <p-button (click)="onValidatingModification(product)" [loading]="isValidatingProduct" icon="pi pi-check" severity="warn" variant="outlined" pTooltip="J'accuse lecture des modifications" tooltipPosition="left"/>
                            </div>
                        </div>
<!--                    </p-message>-->
                </div>
            }
            <p-tabpanels class="block rounded-md">
                <p-tabpanel [value]="0">
                    <app-product-detail-stocks [(product)]="product" [tabIndex]="0" [(tabStates)]="tabStates"></app-product-detail-stocks>
                </p-tabpanel>
                <p-tabpanel [value]="1">
                    <app-product-detail-infos [(product)]="product" [tabIndex]="1" [(tabStates)]="tabStates"></app-product-detail-infos>
                </p-tabpanel>
                <p-tabpanel [value]="3">
                    <app-product-detail-expeditions [(product)]="product" [tabIndex]="3" [(tabStates)]="tabStates"></app-product-detail-expeditions>
                </p-tabpanel>
                <!-- <p-tabpanel [value]="4">
                    <app-product-detail-documents [(product)]="product" [tabIndex]="4" [(tabStates)]="tabStates"></app-product-detail-documents>
                </p-tabpanel> -->
                <p-tabpanel [value]="5">
                    <app-product-detail-historiques [(product)]="product" [tabIndex]="5" [(tabStates)]="tabStates"></app-product-detail-historiques>
                </p-tabpanel>
                <p-tabpanel [value]="6">
                    <app-product-detail-photos [(product)]="product" [tabIndex]="6" [(tabStates)]="tabStates"></app-product-detail-photos>
                </p-tabpanel>
                <p-tabpanel [value]="7">
                    <app-product-detail-distribution [(product)]="product" [tabIndex]="7" [(tabStates)]="tabStates"></app-product-detail-distribution>
                </p-tabpanel>
            </p-tabpanels>
        </div>
    </div>
</p-tabs>
